import { render, staticRenderFns } from "./FormBasicInfo.vue?vue&type=template&id=bcccc292&scoped=true"
import script from "./FormBasicInfo.vue?vue&type=script&lang=js"
export * from "./FormBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./FormBasicInfo.vue?vue&type=style&index=0&id=bcccc292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcccc292",
  null
  
)

export default component.exports